<div class="d-flex justify-content-between align-items-center">

    <app-vehicle-status-label [status]="status?.type"
                              *ngIf="status"></app-vehicle-status-label>
    <p class="c-vehicle-status__time" *ngIf="status">{{timeLabel}}</p>
</div>
